import React from 'react';

export const context = React.createContext(null);
// export const context =  React.createContext<TodoContextType | null>(null);
// const TodoProvider: React.FC<React.ReactNode>
